import { useEffect } from 'react';
import { generatePath, Outlet, useNavigate, useParams } from 'react-router-dom';
import { tr } from '@repo/locale';
import { TestId } from '@repo/test-id';
import { toast } from '@repo/toast';

import { useUnavailabilitiesContext } from '@features/ownedParkingManage/contexts/UnavailabilitiesContext';

import { ROUTE_PATHS } from '@router/paths';
import { RouteName } from '@router/routeNames';

export default function UnavailabilityExistsGuard() {
  const { unavailabilityId, id: parkingId } = useParams<{ unavailabilityId: string; id: string }>();
  const unavailabilities = useUnavailabilitiesContext();
  const navigate = useNavigate();

  const unavailability = unavailabilities.find((candidate) => candidate.id === unavailabilityId);

  useEffect(() => {
    if (!unavailability) {
      const testId = TestId.root('unavailabilityExistsGuardError');
      toast.danger(tr('owned_parking_manage:manage.unavailabilities.guard.not_found'), testId);
      navigate(generatePath(ROUTE_PATHS[RouteName.MY_PARKING_MANAGE_UNAVAILABILITIES], { id: parkingId }), {
        replace: true,
      });
    }
  }, [unavailability, navigate, parkingId]);

  if (!unavailability) {
    return null;
  }

  return <Outlet context={unavailability} />;
}
